export const Modes = {
  IND: 1,
  CON: 2,
  GRP: 3,
};

export enum ForecastModes {
  INDIVIDUAL = 1,
  CONCURRENT = 2,
  GROUP = 3,
}

export enum ForecastModeNames {
  INDIVIDUAL = 'IND',
  CONCURRENT = 'CONC',
  GROUP = 'GRP',
}

export enum ContractWarningDialogMode
{
  DRAFT,
  INCOMPLETE
}